import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'query-string';
import { IPeriod } from '../utils/types';
import moment from 'moment';

export const isInQueryParamsArray = (
  filter: {
    [key: string]: string;
  },
  params?: {
    [key: string]: string | string[];
  }
) => {
  const key = Object.keys(filter)[0];
  const filterValue = filter[key];
  if (params && params[key]) {
    return Array.isArray(params[key])
      ? params[key].includes(filterValue)
      : params[key] === filterValue;
  }
  return false;
};

export const toggleParamInQuery = (
  filter: {
    [key: string]: string;
  },
  params: {
    [key: string]: string | string[];
  }
) => {
  const key = Object.keys(filter)[0];
  if (isInQueryParamsArray(filter, params)) {
    if (Array.isArray(params[key])) {
      const newFilters = [...(params[key] as string[])];
      newFilters.splice(newFilters.indexOf(filter[key]), 1);
      return {
        ...params,
        [key]: newFilters,
      };
    } else {
      return {
        ...params,
        [key]: [],
      };
    }
  } else {
    if (Array.isArray(params[key])) {
      const newFilters = [...(params[key] as string[]), filter[key]];
      return {
        ...params,
        [key]: newFilters,
      };
    } else if (params[key]) {
      return {
        ...params,
        [key]: [params[key], filter[key]],
      };
    } else {
      return {
        ...params,
        ...filter,
      };
    }
  }
};

export const getQueryDatesFromPeriod = (
  period: IPeriod
): {
  startDate: string;
  endDate: string;
} => {
  return {
    startDate: moment(
      new Date(period.startYear, period.startPeriod - 1, 1)
    ).format('YYYY-MM-DD'),
    endDate: moment(new Date(period.endYear, period.endPeriod - 1, 1)).format(
      'YYYY-MM-DD'
    ),
  };
};

type IQueryParam = {
  [key: string]: any;
};

const QueryParams = ({
  children,
}: {
  children: (p: IQueryParam) => React.ReactElement;
}) => {
  const history = useHistory();
  const location = useLocation();
  const params = qs.parse(location.search);

  const setParams = (p: IQueryParam) => {
    const search = qs.parse(location.search);
    const newParams = {
      ...search,
      ...p,
    };
    history.push({
      ...location,
      search: qs.stringify(newParams),
    });
  };

  return children({
    params,
    setParams,
  });
};

export default QueryParams;
